export enum NotFoundTexts {
    TITLE = "Ошибка 404",
    DESCRIPTION = "По какой-то причине вы попали туда, где не должны были оказаться",
    CHECK_LINK = "Проверьте адрес ссылки",
    SUPPORT = "Обратитесь в поддержку",
    RETURN_MAIN_PAGE = "Перейти на главную страницу"
}

export const SUPPORT_MAIL = "mailto:info@likvi.com";